"use client"

import { useEffect, Suspense } from "react"
import { classifyReferrer, trackAcquisition } from "@/lib/analytics"

const ACQUISITION_SESSION_KEY = "bookish_umami_acquisition_v1"

/**
 * Fires once per browser tab session when the user arrived with a non-empty referrer
 * (Umami still records page views, UTMs, and referrer on its own).
 */
function AcquisitionTracker() {
  useEffect(() => {
    if (typeof document === "undefined") return
    const ref = document.referrer
    if (!ref) return
    try {
      const refUrl = new URL(ref)
      if (refUrl.hostname === window.location.hostname) return
      if (sessionStorage.getItem(ACQUISITION_SESSION_KEY)) return
      sessionStorage.setItem(ACQUISITION_SESSION_KEY, "1")
      trackAcquisition({
        source: classifyReferrer(refUrl.hostname),
        referrer_domain: refUrl.hostname.replace(/^www\./, "").slice(0, 120),
      })
    } catch {
      /* invalid referrer URL */
    }
  }, [])

  return null
}

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  // removed: Google Analytics 4 (gtag / NEXT_PUBLIC_GA4_MEASUREMENT_ID)
  // removed: PostHog (NEXT_PUBLIC_POSTHOG_KEY)
  // removed: client POST to /api/analytics/track — replaced by Umami
  return (
    <>
      <Suspense fallback={null}>
        <AcquisitionTracker />
      </Suspense>
      {children}
    </>
  )
}
